"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import { DevicePermissionModel } from "@/models/Auth.model";
import _ from "lodash";
import API from "@ym-framework/api-utils";
let AccountDevice = class extends Vue {
  constructor() {
    super(...arguments);
    this.verifying = false;
    this.permission_type = "form";
    this.device_permission = new DevicePermissionModel();
    this.verify = _.debounce(() => __async(this, null, function* () {
      yield this.verify_btn();
    }), 800);
  }
  open(data, type) {
    return __async(this, null, function* () {
      this.device_permission = data;
      this.permission_type = type;
      this._promission_dialog.show();
    });
  }
  is_dialog_show() {
    return this._promission_dialog._controller.visible;
  }
  verify_btn() {
    return __async(this, null, function* () {
      try {
        this.verifying = true;
        let response = yield API.post(`api://base/api/v6/application`, {
          device_code: this.device_permission.device_code,
          org_guid: this.device_permission.org_guid
        }, {
          headers: {
            "X-AUTH-TOKEN": this.device_permission.token
          }
        });
        this.device_permission.type = "wait";
        this.verifying = false;
      } catch (error) {
        this.verifying = false;
        console.log(error);
      }
    });
  }
};
__decorateClass([
  Ref("promission-dialog")
], AccountDevice.prototype, "_promission_dialog", 2);
AccountDevice = __decorateClass([
  Component({
    components: { UiDialog }
  })
], AccountDevice);
export {
  AccountDevice as default
};
